var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39775 4.89772C1.17808 5.1174 0.821918 5.1174 0.602251 4.89772C0.382583 4.67805 0.382583 4.32192 0.602251 4.10225L3.60227 1.10225C3.82195 0.882583 4.17805 0.882583 4.39772 1.10225L7.39772 4.10225C7.6174 4.32192 7.6174 4.67805 7.39772 4.89772C7.17805 5.1174 6.82195 5.1174 6.60227 4.89772L4.5625 2.85799V10.125C4.5625 10.4356 4.31065 10.6875 4 10.6875C3.68935 10.6875 3.4375 10.4356 3.4375 10.125V2.85799L1.39775 4.89772Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39775 7.10228C9.17808 6.8826 8.82192 6.8826 8.60225 7.10228C8.38258 7.32195 8.38258 7.67808 8.60225 7.89775L11.6023 10.8977C11.8219 11.1174 12.178 11.1174 12.3977 10.8977L15.3977 7.89775C15.6174 7.67808 15.6174 7.32195 15.3977 7.10228C15.178 6.8826 14.8219 6.8826 14.6023 7.10228L12.5625 9.14201V1.875C12.5625 1.56435 12.3106 1.3125 12 1.3125C11.6893 1.3125 11.4375 1.56435 11.4375 1.875V9.14201L9.39775 7.10228Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortArrow);
export default __webpack_public_path__ + "static/media/icon_sortArrow.c8603f17d2a8d97f674bcc248d9b5689.svg";
export { ForwardRef as ReactComponent };